export enum TipoPessoas{
    PessoaFisica,
    PessoaJuridica
}
